export enum IResourcesManagementActionTypes {
	ADD_ACL_RESOURCE = '@@resourcesManagement/ADD_ACL_RESOURCE',
	ADD_ACL_RESOURCE_FAILED = '@@resourcesManagement/ADD_ACL_RESOURCE_FAILED',
	ADD_ACL_RESOURCE_SUCCEED = '@@resourcesManagement/ADD_ACL_RESOURCE_SUCCEED',
	DELETE_ACL_RESOURCE = '@@resourcesManagement/DELETE_ACL_RESOURCE',
	DELETE_ACL_RESOURCE_FAILED = '@@resourcesManagement/DELETE_ACL_RESOURCE_FAILED',
	DELETE_ACL_RESOURCE_SUCCEED = '@@resourcesManagement/DELETE_ACL_RESOURCE_SUCCEED',
	EMPTY_LIST_ACL_RESOURCES = '@@resourcesManagement/EMPTY_LIST_ACL_RESOURCES',
	GET_ACL_RESOURCE = '@@resourcesManagement/GET_ACL_RESOURCE',
	GET_ACL_RESOURCE_FAILED = '@@resourcesManagement/GET_ACL_RESOURCE_FAILED',
	GET_ACL_RESOURCE_SUCCEED = '@@resourcesManagement/GET_ACL_RESOURCE_SUCCEED',
	GET_ACL_RESOURCES = '@@resourcesManagement/GET_ACL_RESOURCES',
	GET_ACL_RESOURCES_FAILED = '@@resourcesManagement/GET_ACL_RESOURCES_FAILED',
	GET_ACL_RESOURCES_SUCCEED = '@@resourcesManagement/GET_ACL_RESOURCES_SUCCEED',
	GET_ACL_RESOURCESPARENTS = '@@resourcesManagement/GET_ACL_RESOURCESPARENTS',
	GET_ACL_RESOURCESPARENTS_FAILED = '@@resourcesManagement/GET_ACL_RESOURCESPARENTS_FAILED',
	GET_ACL_RESOURCESPARENTS_SUCCEED = '@@resourcesManagement/GET_ACL_RESOURCESPARENTS_SUCCEED',
	GET_ACL_RESOURCESTYPES = '@@resourcesManagement/GET_ACL_RESOURCESTYPES',
	GET_ACL_RESOURCESTYPES_FAILED = '@@resourcesManagement/GET_ACL_RESOURCESTYPES_FAILED',
	GET_ACL_RESOURCESTYPES_SUCCEED = '@@resourcesManagement/GET_ACL_RESOURCESTYPES_SUCCEED',
	UPDATE_ACL_RESOURCE = '@@resourcesManagement/UPDATE_ACL_RESOURCE',
	UPDATE_ACL_RESOURCE_FAILED = '@@resourcesManagement/UPDATE_ACL_RESOURCE_FAILED',
	UPDATE_ACL_RESOURCE_SUCCEED = '@@resourcesManagement/UPDATE_ACL_RESOURCE_SUCCEED',
	SET_LOADING_ACLRESOURCES = '@@resourcesManagement/SET_LOADING_ACLRESOURCES',
	SET_CREATING_RESOURCE = '@@resourcesManagement/SET_CREATING_RESOURCE',
}

export interface IResourcesManagementState {
	readonly aclResource: ACLResource | null;
	readonly allACLResources: ACLResource[];
	readonly allACLResourcesParents: ACLResource[];
	readonly allACLResourcesTypes: ACLResourceType[];
	readonly loadingACLResources: boolean;
	readonly isCreatingResource: boolean;
}

export interface ACLResource {
	readonly children: ACLResource[];
	readonly id: number;
	readonly isparent: boolean;
	readonly name: string;
	readonly parent: ACLResource;
	readonly type: ACLResourceType;
}

export interface ACLResourceType {
	readonly id: number;
	readonly name: string;
}
